/**
 * Returns true for invalid count. Currently 0 and -ve values are invalid
 * @param {Number} count
 * @returns Boolean
 */
export const isInvalidValue = (count) => count < 1;

/**
 * Ceils count at 99 because we can't display more than that in our badge
 * @param {Number} count
 * @returns Number
 */
export const getDisplayValue = (count) => (count > 99 ? 99 : count);
